import styled from 'styled-components/macro'
import Box from 'components/shared/Box'
import { respondAbove } from 'styles/mediaQueries'
import splashLeft from 'assets/images/decors/splashLeft.svg'

export const FailedPageWrapper = styled(Box)`
    img {
        max-height: 203px;
    }

    > p:not(:first-of-type) {
        max-width: 706px;
    }

    a {
        align-self: flex-start;
    }

    @media ${respondAbove.xl} {
        > p:first-of-type {
            position: relative;
            ::before {
                position: absolute;
                left: -38px;
                content: '';
                background: url(${splashLeft});
                width: 28px;
                height: 48px;
            }
            ::after {
                position: absolute;
                right: -38px;
                content: '';
                background: url(${splashLeft});
                width: 28px;
                height: 48px;
                transform: rotate(180deg);
            }
        }
        a {
            align-self: center;
        }

        img {
            max-height: 322px;
        }
    }
`
